import { COLUMNS_REPORTE_EMBARQUE_SECTOR_12_LINEA_7_TO_PRINT, COLUMNS_REPORTE_EMBARQUE_SECTOR_12_LINEA_7 } from './constantesReporteEmbarqueSector12Linea7'
import { TABLA_REPORTE_EMBARQUE_SECTOR_12_LINEA_7 } from '../../../../../../config/tables'
import { ReporteEmbarqueSector12Linea7Service } from '../../../../../../models/movimiento/ReporteEmbarquePorSector/tabla_reporte_embarque_sector_12_linea_7'
import { pdfCustomToolbarGenerator } from '../../../../../../models/tools/generarPdf'

export function actualizarDatosParaMuiTable (cereal, cerealVariedad, etiqueta) {
  return dispatch => {
    dispatch({
      type: 'UPDATE_MUITABLE',
      newState: {
        isLoading: true
      },
      id: TABLA_REPORTE_EMBARQUE_SECTOR_12_LINEA_7
    })
    const promiseReporteEmbarqueSector12Linea7 = ReporteEmbarqueSector12Linea7Service.getDataReporteEmbarqueSector12Linea7(cereal, cerealVariedad, etiqueta)
    const promiseReporteEmbarqueSector12Linea7Total = ReporteEmbarqueSector12Linea7Service.getDataReporteEmbarqueSector12Linea7Total(cereal, cerealVariedad, etiqueta)
    Promise.all([promiseReporteEmbarqueSector12Linea7, promiseReporteEmbarqueSector12Linea7Total]).then(callback)
    function callback (dataArray) {
      const dataCombinada = dataArray[0].filas || []
      const filaTotalArreglada = (dataArray[1].filas || [])[0] || {}
      filaTotalArreglada['silo'] = 'Total'
      filaTotalArreglada['pesoNetoBaseVigente'] = filaTotalArreglada['sum']
      console.log(filaTotalArreglada)
      dataCombinada.push(filaTotalArreglada)
      const customToolbar = pdfCustomToolbarGenerator(
        'Sector 1-2 Linea 7',
        dataCombinada,
        COLUMNS_REPORTE_EMBARQUE_SECTOR_12_LINEA_7_TO_PRINT,
        'portrait')
      dispatch({
        type: 'UPDATE_MUITABLE',
        newState: {
          columns: COLUMNS_REPORTE_EMBARQUE_SECTOR_12_LINEA_7,
          data: dataCombinada,
          title: `Sector 1-2 Linea 7`,
          isLoading: false,
          fixed2Decimales: false,
          extraOptions: { customToolbar, pagination: false }
        },
        id: TABLA_REPORTE_EMBARQUE_SECTOR_12_LINEA_7
      })
    }
  }
}
